import React, { FC, useMemo, useState, useEffect } from "react";
import ListingsPageHeader from "components/Heading/ListingsPageHeader";
import StayCardAlternative from "components/StayCard/StayCardAlternative";
import StayCardAlternativeSkeleton from "components/StayCard/StayCardAlternativeSkeleton";
import PaginationComponent from "shared/Pagination/PaginationExt";

import AlternativeGrid from "./AlternativeGrid";


export interface SectionGridFilterCardProps {
  loading: boolean;
  className?: string;
  listings: Array<any>; // Define listings as array of any (replace with your data type)
  cachedListings?: Array<any>;
}

const ITEMS_PER_PAGE = 9;

const CalendarViewFilterCard: FC<SectionGridFilterCardProps> = ({
  loading,
  className = "",
  listings,
  cachedListings = [],
}) => {
  const [currentPage, setCurrentPage] = useState(0); // Track the current page
  const [currentPageListings, setCurrentPageListings] = useState<any[]>([]);

  const skeletonLength = Array(ITEMS_PER_PAGE).fill(0);

  // Combine listings and cachedListings to calculate displayListings
  const displayListings = useMemo(() => {
    if (loading) return []; // Avoid unnecessary computation during loading
    return listings.length > 0 ? listings : cachedListings;
  }, [loading, listings, cachedListings]);

  // Calculate the items to display whenever `currentPage` or `displayListings` changes
  useEffect(() => {
    if (displayListings.length === 0) return; // Skip if no listings available yet
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    setCurrentPageListings(displayListings.slice(startIndex, endIndex));
  }, [currentPage, displayListings]);

  // Memoize listing cards or skeletons based on loading and currentPageListings
  const memoizedListingCards = useMemo(() => {
    if (loading) {
      return skeletonLength.map((_, index) => (
        <StayCardAlternativeSkeleton key={`skeleton-${index}`} />
      ));
    } else {
      return  ( <AlternativeGrid listings={currentPageListings}/>)
        //<StayCardAlternative key={stay.id} data={stay} />

      
      ;
    }
  }, [loading, currentPageListings]);

  // Handle page change
  const handlePageChange = (selectedPage: number) => {
    setCurrentPage(selectedPage);
  };

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <ListingsPageHeader />
      <div className="mb-8 lg:mb-11">{/* <TabFilters /> */}</div>

      <div className="grid grid-cols-1 gap-6 md:gap-8">
        {memoizedListingCards}
      </div>


      {/* Show pagination only if there are more items than ITEMS_PER_PAGE */}
      {!loading && displayListings.length > ITEMS_PER_PAGE && (
        <div className="flex mt-16 justify-center items-center">
          <PaginationComponent
            totalItems={displayListings.length}
            itemsPerPage={ITEMS_PER_PAGE}
            onPageChange={handlePageChange}
            currentPage={1}
          />
        </div>
      )}
    </div>
  );
};

export default CalendarViewFilterCard;
